import { Action } from 'redux';

// Clear Client
export const CLEAR_CLIENT = 'clients/CLEAR_CLIENT';
export interface ClearClientAction extends Action<typeof CLEAR_CLIENT> {}
export const clearClient = (): ClearClientAction => ({
  type: CLEAR_CLIENT,
});

// Get Client
export const GET_CLIENT = 'clients/GET_CLIENT';
export interface GetClientAction extends Action<typeof GET_CLIENT> {
  readonly payload: {
    readonly id: ModelID;
  };
}
export const getClientById = (id: ModelID): GetClientAction => ({
  payload: {
    id,
  },
  type: GET_CLIENT,
});

// Get Client Success
export const GET_CLIENT_SUCCESS = 'clients/GET_CLIENT_SUCCESS';
export interface GetClientSuccessAction extends Action<typeof GET_CLIENT_SUCCESS> {
  readonly payload: Client;
}

export const getClientContent = (data: GetClientSuccessAction['payload']): GetClientSuccessAction => ({
  type: GET_CLIENT_SUCCESS,
  payload: data,
});

// All Client actions
export type ClientAction = ClearClientAction | GetClientAction | GetClientSuccessAction;
